import * as React from "react";
import Modal, { ModalSize } from "../../../../misc/components/modal";
import { WizardActionTypes, WizardState } from '../WizardTypings';
import { EnterNewSubjectType } from './SelecteNewSubjectType';
import LoadingWithMessage from "../../../../misc/components/LoadingWithMessage";
import { CorrectionPreviewModal } from '../../CorrectionPreviewModal';
import { VisibleWizards, Correction } from '../../../Request/DcfRequestReducer';
import { useWizard } from '../../../Hooks/UseWizard';
import { Form } from "informedv4";
import { WebPortalClient, SubjectType } from "webportalclient";
import { useWebPortalApiClient } from "../../../../misc/api/WebPortalTokenClient";
import { CorrectionTypesEnum } from "../../../../misc/api/apiTypes";


export interface SubjectTypeCorrectionWizardProps {
    isVisible: boolean;
    onClose: () => void;
    originalSubjectType: string;
    onComplete: (corrections: Correction[]) => void;
    correctedSubjectType: string;
}

export const SubjectTypeCorrectionWizard = ({ isVisible, onClose, originalSubjectType, onComplete, correctedSubjectType }: SubjectTypeCorrectionWizardProps): JSX.Element => {
    const { currentState, dispatch } = useWizard();
    const client = useWebPortalApiClient();
    const [newSubjectType, setNewSubjectType] = React.useState(correctedSubjectType);
    const [loadingSubjectTypes, setLoadingSubjectTypes] = React.useState<boolean>(true);
    const [subjectTypes, setSubjectTypes] = React.useState<SubjectType[]>([]);

    React.useEffect(() => {
        setLoadingSubjectTypes(true);
        client.client.getSubjectTypes()
            .then((st) => {
                setSubjectTypes(st.value);

                setLoadingSubjectTypes(false);
            });

    }, [client.client]);

    if (!isVisible) {
        return null;
    }

    if (loadingSubjectTypes) {
        return <LoadingWithMessage message="Loading Subject Types" />;
    }

    const getSubjectTypeName = (code: string): string => {
        return code ? subjectTypes.find(st => st.id === code).name : "";
    }

    let page = null;
    switch (currentState.page) {
        case 0:
            page = (
                <Form validateOn="submit" initialValues={{ originalSubjectType: originalSubjectType, correctedSubjectType: newSubjectType || originalSubjectType }}>
                    <EnterNewSubjectType
                        onNext={(newSubjectType) => {
                            setNewSubjectType(newSubjectType);
                            dispatch(WizardActionTypes.Next);
                        }}
                        originalSubjectType={originalSubjectType}
                        subjectTypes={subjectTypes}
                    />
                </Form>
            );
            break;
        case 1:
            const corrections = [{
                sourceCorrection: VisibleWizards.SubjectType,
                correctionTypeId: CorrectionTypesEnum.SubjectType,
                entity: "Subject",
                field: "Type",
                oldValue: originalSubjectType,
                newValue: newSubjectType
            }];
            page = (
                <CorrectionPreviewModal
                    corrections={corrections}
                    miscCorrection={null}
                    onNext={(): void => {dispatch(WizardActionTypes.Reset); onComplete(corrections) }}
                    onPrev={(): void => dispatch(WizardActionTypes.Previous)}
                />
            );
            break;
        default:
            page = null;
    }

    return (
        <Modal show={true} header={"Change Subject Type"} size={ModalSize.Large} closeModalHandler={onClose}>
            {page}
        </Modal>
    );
};
